import { useLanguage } from "../lib/LanguageContext/LanguageContext.tsx";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type LocalizedItem = Record<string, any>;

export const useLocalizedContent = () => {
  const { currentLang } = useLanguage();

  const getLocalizedValue = <T extends LocalizedItem>(
    item: T,
    key: keyof T & string
  ): string => {
    const zhKey = `${key}Zh` as keyof T;
    if (currentLang === "zh" && item[zhKey]) {
      return item[zhKey] as string;
    }
    return item[key] as string;
  };

  const getLocalizedDate = (date: string, dateZh?: string): string => {
    return currentLang === "zh" && dateZh ? dateZh : date;
  };

  return {
    getLocalizedValue,
    getLocalizedDate,
    isZh: currentLang === "zh",
  };
};
